module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/passenger-manual-notif/passenger-manual-notif-show/passenger-manual-notif-show.component.css
// module id = ./src/app/components/passenger-manual-notif/passenger-manual-notif-show/passenger-manual-notif-show.component.css
// module chunks = main